/**
 * In-memory App Order list snapshot so Back from details restores
 * the exact previous table/filters without refetching APIs.
 */

const EXPECT_RETURN_KEY = 'app_order_expect_list_return';

let listSnapshot = null;
/** Frozen copy taken when opening details — survives React Strict Mode remount. */
let frozenSnapshotForReturn = null;
let clearFrozenTimer = null;

export const setAppOrderListSnapshot = (snapshot) => {
  listSnapshot = snapshot;
};

export const getAppOrderListSnapshot = () => listSnapshot;

export const clearAppOrderListSnapshot = () => {
  listSnapshot = null;
};

export const markAppOrderExpectReturn = () => {
  try {
    sessionStorage.setItem(EXPECT_RETURN_KEY, '1');
  } catch (error) {
    console.error('Failed to mark App Order return:', error);
  }
  // Freeze current list UI at the moment of opening details
  frozenSnapshotForReturn = listSnapshot;
  if (clearFrozenTimer) {
    clearTimeout(clearFrozenTimer);
    clearFrozenTimer = null;
  }
};

/** True while Back-from-details restore is pending (does not consume the snapshot). */
export const isAppOrderListReturnPending = () => {
  try {
    return (
      sessionStorage.getItem(EXPECT_RETURN_KEY) === '1' ||
      frozenSnapshotForReturn != null
    );
  } catch (error) {
    return frozenSnapshotForReturn != null;
  }
};

/**
 * Returns frozen list snapshot when returning from order details.
 * Safe under React Strict Mode (double-mount): snapshot stays available briefly.
 */
export const takeAppOrderListSnapshotIfReturning = () => {
  try {
    const flagged = sessionStorage.getItem(EXPECT_RETURN_KEY) === '1';
    if (frozenSnapshotForReturn) return frozenSnapshotForReturn;
    if (flagged) return listSnapshot;
    return null;
  } catch (error) {
    return frozenSnapshotForReturn || null;
  }
};

/** Call after applying restore. Clears expect flag; keeps frozen briefly for Strict remount. */
export const acknowledgeAppOrderListRestore = () => {
  try {
    sessionStorage.removeItem(EXPECT_RETURN_KEY);
  } catch (error) {
    // ignore
  }
  if (clearFrozenTimer) clearTimeout(clearFrozenTimer);
  clearFrozenTimer = setTimeout(() => {
    frozenSnapshotForReturn = null;
    clearFrozenTimer = null;
  }, 1000);
};
